module.exports = __webpack_public_path__ + "static/img/rectangle.5206867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rectangle.png
// module id = qN4d
// module chunks = 1